import React from "react";
import classes from "./InfoTextFields.module.css";

const InfoTextFields = (props) => {
  const { moduleClasses } = props;
  return <div className={classes[moduleClasses]}>{props.children}</div>;
};

export default InfoTextFields;
